import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { usePartnerEncumbrances } from './context/PartnerEncumbrancesContext';
import PartnerEncumbrancesBody from './components/PartnerEncumbrancesBody';
import PartnerEncumbrancesHeader from './components/PartnerencumbrancesHeader';

const PartnerEncumbrances: FC = () => {
  const { data } = usePartnerEncumbrances();
  return (
    <>
      <PartnerEncumbrancesHeader />
      <PartnerEncumbrancesBody />

      {data.isLoading && <CustomLoading />}
    </>
  );
};
export default PartnerEncumbrances;
